// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'speaker-mute-solid';

export const Component = () => (
  <path d='m10.988 16.8 7.758-11.064v14.416c0 .43-.144.766-.431 1.053-.24.24-.623.383-1.054.383-.383 0-.67-.096-.91-.287l-5.364-4.502ZM17.07 3.005 7.49 16.704H5.959a.946.946 0 0 1-.67-.288.946.946 0 0 1-.288-.67V8.85c0-.239.096-.479.287-.67a.946.946 0 0 1 .67-.288h4.934l5.459-4.597c.24-.144.479-.24.719-.288Zm2.49-.91c.144.144.192.24.192.383 0 .144-.048.24-.097.287L5.862 22.402a.435.435 0 0 1-.382.192c-.335 0-.48-.144-.48-.48 0-.143.048-.238.097-.287L18.842 2.191A.435.435 0 0 1 19.225 2c.048 0 .144.048.335.096Z' />
);

export const viewBox = '0 0 25 25';
